import { AppShell } from '@/components/AppShell';
import { useUser } from '@clerk/react';
import { User, Mail, Calendar } from 'lucide-react';
import { format } from 'date-fns';

export default function SettingsPage() {
  const { user, isLoaded } = useUser();

  return (
    <AppShell>
      <div className="p-8 max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="font-sans font-bold tracking-tight text-3xl md:text-4xl text-foreground mb-2">Settings</h1>
          <p className="text-muted-foreground">Manage your account settings</p>
        </div>

        {isLoaded && user ? (
          <div className="space-y-6">
            <div className="p-6 rounded-lg border border-card-border bg-card shadow-[var(--shadow-card)]">
              <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
                <User className="w-5 h-5" />
                Account Information
              </h2>
              <div className="space-y-4">
                <div>
                  <label className="text-sm text-muted-foreground block mb-1">Name</label>
                  <div className="text-foreground" data-testid="text-user-name">
                    {user.fullName || user.firstName || 'Not set'}
                  </div>
                </div>
                <div>
                  <label className="text-sm text-muted-foreground block mb-1 flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    Email Address
                  </label>
                  <div className="text-foreground" data-testid="text-user-email">
                    {user.primaryEmailAddress?.emailAddress || 'Not set'}
                  </div>
                </div>
                <div>
                  <label className="text-sm text-muted-foreground block mb-1 flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    Member Since
                  </label>
                  <div className="text-foreground">
                    {user.createdAt ? format(new Date(user.createdAt), 'MMMM d, yyyy') : 'Unknown'}
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 rounded-lg border border-card-border bg-card shadow-[var(--shadow-card)]">
              <h2 className="text-lg font-semibold text-foreground mb-4">Need to update your account?</h2>
              <p className="text-muted-foreground text-sm mb-4">
                For security reasons, account changes should be made through your authentication provider.
              </p>
              <p className="text-sm text-muted-foreground">
                Use the "Sign Out" button in the sidebar to log out.
              </p>
            </div>
          </div>
        ) : (
          <div className="p-6 rounded-lg border border-border bg-card animate-pulse">
            <div className="h-64" />
          </div>
        )}
      </div>
    </AppShell>
  );
}
